export default {
    'zh_CN': {
        'system.dict-type.id.label': '主键ID',
        'system.dict-type.id.holder': '请输入主键ID',


        'system.dict-type.id.required': '主键ID必填',
        'system.dict-type.label.label': '字典名称',
        'system.dict-type.label.holder': '请输入字典名称',
        'system.dict-type.label.max': '字典名称最多100个字符',

        'system.dict-type.label.required': '字典名称必填',
        'system.dict-type.sign.label': '字典类型',
        'system.dict-type.sign.holder': '请输入字典类型',
        'system.dict-type.sign.max': '字典类型最多100个字符',

        'system.dict-type.sign.required': '字典类型必填',
        'system.dict-type.status.label': '状态',
        'system.dict-type.status.holder': '请输入状态',


        'system.dict-type.status.dictionary': ()=>[{value:0,label:'禁用'},{value:1,label:'启用'}],
        'system.dict-type.status.required': '状态必填',
        'system.dict-type.remark.label': '备注',
        'system.dict-type.remark.holder': '请输入备注',
        'system.dict-type.remark.max': '备注最多500个字符',

        'system.dict-type.remark.required': '备注必填',
        'system.dict-type.createTime.label': '创建时间',
        'system.dict-type.createTime.holder': '请输入创建时间',
        'system.dict-type.createTime.required': '创建时间必填',
        'system.dict-type.updateTime.label': '更新时间',
        'system.dict-type.updateTime.holder': '请输入更新时间',
        'system.dict-type.updateTime.required': '更新时间必填',
        'system.dict-type.deleted.label': '是否删除',
        'system.dict-type.deleted.holder': '请输入是否删除',
        'system.dict-type.deleted.required': '是否删除必填'
    },
    'zh_TW': {
        'system.dict-type.id.label': '主键ID',
        'system.dict-type.id.holder': '請輸入主键ID',


        'system.dict-type.id.required': '主键ID必填',
        'system.dict-type.label.label': '字典名称',
        'system.dict-type.label.holder': '請輸入字典名称',


        'system.dict-type.label.required': '字典名称必填',
        'system.dict-type.sign.label': '字典类型',
        'system.dict-type.sign.holder': '請輸入字典类型',


        'system.dict-type.sign.required': '字典类型必填',
        'system.dict-type.status.label': '状态',
        'system.dict-type.status.holder': '請輸入状态',


        'system.dict-type.status.required': '状态必填',
        'system.dict-type.remark.label': '备注',
        'system.dict-type.remark.holder': '請輸入备注',


        'system.dict-type.remark.required': '备注必填',
        'system.dict-type.createTime.label': '创建时间',
        'system.dict-type.createTime.holder': '請輸入创建时间',


        'system.dict-type.createTime.required': '创建时间必填',
        'system.dict-type.updateTime.label': '更新时间',
        'system.dict-type.updateTime.holder': '請輸入更新时间',


        'system.dict-type.updateTime.required': '更新时间必填',
        'system.dict-type.deleted.label': '是否删除',
        'system.dict-type.deleted.holder': '請輸入是否删除',


        'system.dict-type.deleted.required': '是否删除必填'
    },
    'en_US': {
        'system.dict-type.id.label': 'id',
        'system.dict-type.id.holder': 'Enter id',
        'system.dict-type.id.max': 'id max length: 主键ID',


        'system.dict-type.id.required': 'id required',
        'system.dict-type.label.label': 'label',
        'system.dict-type.label.holder': 'Enter label',
        'system.dict-type.label.max': 'label max length: 字典名称',


        'system.dict-type.label.required': 'label required',
        'system.dict-type.sign.label': 'sign',
        'system.dict-type.sign.holder': 'Enter sign',
        'system.dict-type.sign.max': 'sign max length: 字典类型',


        'system.dict-type.sign.required': 'sign required',
        'system.dict-type.status.label': 'status',
        'system.dict-type.status.holder': 'Enter status',
        'system.dict-type.status.max': 'status max length: 状态',


        'system.dict-type.status.required': 'status required',
        'system.dict-type.remark.label': 'remark',
        'system.dict-type.remark.holder': 'Enter remark',
        'system.dict-type.remark.max': 'remark max length: 备注',


        'system.dict-type.remark.required': 'remark required',
        'system.dict-type.createTime.label': 'createTime',
        'system.dict-type.createTime.holder': 'Enter createTime',
        'system.dict-type.createTime.max': 'createTime max length: 创建时间',


        'system.dict-type.createTime.required': 'createTime required',
        'system.dict-type.updateTime.label': 'updateTime',
        'system.dict-type.updateTime.holder': 'Enter updateTime',
        'system.dict-type.updateTime.max': 'updateTime max length: 更新时间',


        'system.dict-type.updateTime.required': 'updateTime required',
        'system.dict-type.deleted.label': 'deleted',
        'system.dict-type.deleted.holder': 'Enter deleted',
        'system.dict-type.deleted.max': 'deleted max length: 是否删除',


        'system.dict-type.deleted.required': 'deleted required'
    }
}
